import Phaser from 'phaser';

// === POLISH UI POUR BOUTONS ===
// Helpers légers pour ajouter du "wahou" aux boutons existants sans refactor.
// Tous les helpers sont opt-in : on appelle après création du bouton.

/**
 * Ajoute un effet de pulsation au survol : scale 1.0 → 1.05 et retour.
 * Marche sur tout GameObject avec scaleX/scaleY (Text, Rectangle, Sprite, Image).
 * Idempotent : safe à appeler plusieurs fois (les listeners se cumulent — éviter).
 */
export function addHoverPulse(
  scene: Phaser.Scene,
  obj: Phaser.GameObjects.GameObject & { scaleX: number; scaleY: number; setScale: (s: number) => unknown },
  scale: number = 1.05,
): void {
  const baseScale = obj.scaleX || 1;
  obj.on('pointerover', () => {
    scene.tweens.add({
      targets: obj,
      scaleX: baseScale * scale,
      scaleY: baseScale * scale,
      duration: 120,
      ease: 'Sine.easeOut',
    });
  });
  obj.on('pointerout', () => {
    scene.tweens.add({
      targets: obj,
      scaleX: baseScale,
      scaleY: baseScale,
      duration: 120,
      ease: 'Sine.easeOut',
    });
  });
}

/**
 * Définit le curseur CSS de la scène selon le contexte.
 * - 'default' / 'pointer' / 'crosshair' / 'help' / 'wait' / 'progress'
 * - URL PNG : `url('path.png'), pointer`
 * Reset automatique au shutdown de la scène.
 */
export function setSceneCursor(scene: Phaser.Scene, cursor: string): void {
  scene.input.setDefaultCursor(cursor);
  scene.events.once('shutdown', () => scene.input.setDefaultCursor('default'));
  scene.events.once('destroy', () => scene.input.setDefaultCursor('default'));
}
